import * as React from 'react'
import {ReactNode} from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {NatFamilyStructure,} from '../NatResidentApplicationInterface'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {getFormattedAddress, getFormattedDate} from '../helper/NatContactAddressOnEmergencyHelper'
import {toFullWidthNumber} from '../../../../common/util/Natutil'

interface Props {
    familyStructureList: Nullable<NatFamilyStructure[]>
}

const NatResidentFamilyStructureConfirmView = (props: Props) => {
    const {familyStructureList} = props

    if (!familyStructureList) {
        return <></>
    }

    const renderDetail: ReactNode[] = []

    familyStructureList.map(familyStructure => {
        const {
            index, relationship, familyName, firstName,
            familyNameKana, firstNameKana, birthYear, birthMonth, birthDay, workAddress
        } = familyStructure
        const {name, zipCode, prefecture, address2, address3, buildingRoomNumber, phoneNumber} = workAddress

        const items = []
        items.push(`続柄：${relationship}`)
        items.push(`氏名：${familyName} ${firstName}（${familyNameKana} ${firstNameKana}）`)
        if (birthYear && birthMonth && birthDay) {
            items.push(`生年月日：${getFormattedDate(`${birthYear}-${birthMonth}-${birthDay}`)}`)
        } else {
            items.push(`生年月日：`)
        }
        items.push(`勤務先：${name}`)
        items.push(`勤務先住所： ${getFormattedAddress(zipCode, prefecture, address2, address3, buildingRoomNumber)}`)
        items.push(`勤務先電話番号：${phoneNumber}`)

        renderDetail.push(
            <React.Fragment key={`family_${index}`}>
                <NatResidentApplicationDetailConfirmItem
                    title={`家族${toFullWidthNumber(index + 1)}`}
                    items={items}
                />
                <BlockSpacer height={'5px'}/>
            </React.Fragment>
        )
    })

    return (<>
        {renderDetail}
    </>)
}

NatResidentFamilyStructureConfirmView.displayName = 'NatResidentFamilyStructureConfirmView'
export default NatResidentFamilyStructureConfirmView